import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';  // Import the `Trans` component
import './App.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();  // Get the translation function

  return (
    <div className="privacy-policy">
      <h1>{t('privacy_policy_title')}</h1>
      <p><strong>{t('effective_from')}</strong> 20.01.2025</p>

      <p>{t('privacy_policy_intro')}</p>

      <h2>{t('data_we_collect_title')}</h2>
      <p>{t('data_we_collect')}</p>

      <h2>{t('how_we_use_data_title')}</h2>
      <p>{t('how_we_use_data')}</p>

      <h2>{t('sharing_data_with_third_parties_title')}</h2>
      <p>{t('sharing_data_with_third_parties')}</p>

      <h2>{t('cookies_and_similar_technologies_title')}</h2>
      <Trans>
        {t('cookies_and_similar_technologies')} 
        <Link to="/politika-piskotkov">{t('cookie_policy')}</Link>
      </Trans>

      <h2>{t('contact_title')}</h2>
      <p>{t('privacy_policy_contact_intro')}</p>
      <ul>
        <li><strong>{t('nostr_label')}:</strong> npub17yh89gqvkcck494vag8cwep4ah7g8gwe54ussy4vhltxls8gzc5qwrfek5</li>
      </ul>

      <h2>{t('changes_to_privacy_policy_title')}</h2>
      <p>{t('changes_to_privacy_policy')}</p>
    </div>
  );
};

export default PrivacyPolicy;

